import { BillingWidgetCard } from '../../dashboard-widgets';
import type { BillingWidget } from '../../shared/billing';

interface BillingSectionProps {
  billing: BillingWidget | undefined;
  loading?: boolean;
  onOpenReports?: () => void;
}

/**
 * `Billing` section (payment milestones PM-23, AC-16) — billed this month /
 * awaiting payment / next-3-months scheduled, as a full-width tile grid (the
 * `FinancialsSection` idiom; the earlier single capped card orphaned itself
 * beside empty space at tablet/desktop widths). Section gate
 * (`view:reports:financial`) lives in `dashboard/sections.tsx`; this
 * component renders null-safely (via `BillingWidgetCard`) when `billing` is
 * absent, so a stale render path can never show a masked-empty card.
 */
export function BillingSection({ billing, loading, onOpenReports }: BillingSectionProps) {
  return <BillingWidgetCard data={billing} loading={loading} onOpenReports={onOpenReports} />;
}

export default BillingSection;
